import React from 'react'

import { cn } from '@/shared/lib/utils'

type ProgressBarProps = {
	className?: string
	value: number
}
export default function ProgressBar({ className, value }: ProgressBarProps) {
	return (
		<div
			className={cn(
				'flex flex-col justify-center rounded-lg bg-primary text-center',
				className
			)}
			role='progressbar'
			style={{ width: `${value}%` }}
			aria-value-now={value}
			aria-value-min='0'
			aria-value-max='100'
		/>
	)
}
